/**
 * @generated SignedSource<<bdabb3c526c3d81d125c771bad584ad2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountsSubmit_viewer$data = {
  readonly clientToken: {
    readonly value: string | null;
  } | null;
  readonly id: string;
  readonly stripeIsEnabled: boolean | null;
  readonly " $fragmentType": "CheckoutBankAccountsSubmit_viewer";
};
export type CheckoutBankAccountsSubmit_viewer$key = {
  readonly " $data"?: CheckoutBankAccountsSubmit_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountsSubmit_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountsSubmit_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Token",
      "kind": "LinkedField",
      "name": "clientToken",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "stripeIsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "stripeCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"stripeCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "596a59b210793661d8b1f2657e237a7c";

export default node;
